import { render, staticRenderFns } from "./DatatableAreas.vue?vue&type=template&id=b3f18c76&scoped=true&"
import script from "./DatatableAreas.vue?vue&type=script&lang=js&"
export * from "./DatatableAreas.vue?vue&type=script&lang=js&"
import style0 from "./DatatableAreas.vue?vue&type=style&index=0&id=b3f18c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f18c76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
